import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";


export default class SubscriberGrid extends Component 
{
  constructor(props) {
    super(props);
    this.state = {};

    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRowDoubleClicked = this.onRowDoubleClicked.bind(this);

    this.columnDefs = [
      //{ headerName: "SubscriberId", field: "id", resizable: true, sortable: true, filter: true },
      { headerName: "Name", field: "name", resizable: true, sortable: true, filter: true },
      { headerName: "Company", field: "company", resizable: true, sortable: true, filter: true },
      { headerName: "Type", field: "subscriberType", resizable: true, sortable: true, filter: true },
      { headerName: "Role", field: "position", resizable: true, sortable: true, filter: true },
      { headerName: "Active", field: "isActive", resizable: true, sortable: true, filter: true },
      { headerName: "Comments", field: "comments", resizable: true, sortable: true, filter: true },
      { headerName: "Email", field: "transportInfo.email.address", resizable: true, sortable: true, filter: true },
      { headerName: "SMS", field: "transportInfo.sms.address", resizable: true, sortable: true, filter: true },
      //{ headerName: "Email", resizable: true, sortable: true, filter: true, cellRenderer: function (params) { return params.data.transports[0].address } }
  ];
    
  }

  onSelectionChanged() {
    console.log("Changing selected row")
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData = selectedNodes[0].data;
    //var rowNode = selectedNodes[0];
    console.info(rowData);
    this.props.onRowSelectChange(rowData); 
  }

  onRowDoubleClicked(row){
    console.group("On Row Double Clicked Row: ");
    console.log(row.data);
    console.groupEnd();
    var rowData = row.data;
    this.props.onRowSelectChange(rowData);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  render() {
    const divStyle = {
      width: "100%",
      height: "calc(85vh)",
      maxWidth: "99vw",

      //border: '5px solid black'
    };

    const gridOptions = {
      onRowDoubleClicked: this.onRowDoubleClicked
    }

    /*
    if (this.dataReady){
      console.log(" Lines (this.props.rowData) about to be rendered: ");
      console.log(this.props.rowData);
      this.gridApi.setRowData(this.props.rowData);
    }
    */

    const gridData = (this.props.rowData) ? this.props.rowData : [{}];

    return (
      <div className="ag-theme-balham" style={divStyle}>
        <AgGridReact
          rowSelection="single"
          pagination={true}
          columnDefs={this.columnDefs}
          rowData={gridData}
          animateRows={true}
          onGridReady={this.onGridReady}
          onSelectionChanged={this.onSelectionChanged.bind(this)}
          gridOptions = {gridOptions}
          onRowDoubleClicked = {this.props.onEditRequest}
          defaultColDef={{flex:1}}
        />
      </div>
    );
  }
}
